interface HeaderNavbarDataItem {
  id: string;
  title: string;
  to?: string;
  href?: string;
}

interface HeaderNavbarDataType {
  planYourWedding: HeaderNavbarDataItem[];
  resources: HeaderNavbarDataItem[];
}

export const headerNavbarData: HeaderNavbarDataType = {
  planYourWedding: [
    {
      id: 'features-wedding-website',
      to: '/wedding-website',
      title: 'Wedding Website',
    },
    {
      id: 'features-registry',
      to: '/registry',
      title: 'Registry',
    },
    {
      id: 'features-guest-list',
      to: '/guest-list',
      title: 'Guest List',
    },
    {
      id: 'features-save-the-date',
      to: '/save-the-date',
      title: 'Save the Dates',
    },
    {
      id: 'features-wedding-invitations',
      to: '/wedding-invitations',
      title: 'Invitations',
    },
    {
      id: 'features-smart-rsvp',
      to: '/online-rsvp',
      title: 'Smart RSVP',
    },
    {
      id: 'features-app',
      to: '/app',
      title: 'Mobile App',
    },
  ],
  resources: [
    {
      id: 'menu2designs',
      href: '/designs',
      title: 'Design Templates',
    },
    {
      id: 'menu2blog',
      href: 'https://withjoy.com/blog/',
      title: 'Ideas & Inspiration',
    },
    {
      id: 'menu2faq',
      to: '/faq',
      title: 'FAQs',
    },
    {
      id: 'menu2help',
      href: 'https://help.withjoy.com/',
      title: 'Help & Support',
    },
    {
      id: 'menu2pricing',
      to: '/pricing',
      title: 'Pricing',
    },
  ],
};
